import { Badge } from '@mui/material';
import * as R from 'ramda';
import { useSelector } from 'react-redux';

import { ComplianceTypes } from '@/constants';
import {
  selectAssessmentReadyEpisodeIds,
  selectQuizReadyEpisodeData,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

export const IncompleteNotificationBadge = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const compliance = useSelector(selectUserCompliance);

  const assessmentReadyEpisodeIds = useSelector(
    selectAssessmentReadyEpisodeIds,
  );

  const { assessmentReadyEpisodes } = useFetchEpisodesQuery(
    {
      episodeIds: assessmentReadyEpisodeIds,
      compliance,
    },
    {
      skip:
        !assessmentReadyEpisodeIds?.length ||
        compliance !== ComplianceTypes.CPE,
      selectFromResult: result => ({
        ...result,
        assessmentReadyEpisodes: result.data
          ? R.indexBy(R.prop('episodeId'), result.data)
          : undefined,
      }),
    },
  );

  const episodeQuizData = useSelector(selectQuizReadyEpisodeData);
  const { quizReadyEpisodes } = useFetchEpisodesQuery(
    {
      episodeIds: Object.keys(episodeQuizData),
      compliance: ComplianceTypes.CPD,
    },
    {
      skip:
        !Object.keys(episodeQuizData)?.length ||
        compliance !== ComplianceTypes.CPD,
      selectFromResult: result => ({
        ...result,
        quizReadyEpisodes: result.data
          ? R.indexBy(R.prop('episodeId'), result.data)
          : undefined,
      }),
    },
  );

  const incompleteQuizCount =
    Object.entries(episodeQuizData)
      ?.filter(([episodeId]) => !!quizReadyEpisodes?.[episodeId])
      ?.reduce(
        (acc, [_episodeId, availableQuizCount]) => acc + availableQuizCount,
        0,
      ) ?? 0;

  const incompleteAssessmentsCount =
    assessmentReadyEpisodeIds?.filter(id => !!assessmentReadyEpisodes?.[id])
      ?.length ?? 0;

  const badgeContent =
    compliance === ComplianceTypes.CPE
      ? incompleteAssessmentsCount
      : incompleteQuizCount;

  if (!badgeContent) {
    return children;
  }

  return (
    <Badge
      badgeContent={badgeContent}
      color="info"
      sx={{
        '& .MuiBadge-badge': {
          height: '16px',
          minWidth: '16px',
          padding: 0.5,
          bgcolor: 'blue30',
        },
      }}>
      {children}
    </Badge>
  );
};
